class FacetFiltersForm extends HTMLElement {
  constructor() {
    super();
    this.onActiveFilterClick = this.onActiveFilterClick.bind(this);

    this.debouncedOnSubmit = debounce((event) => {
      this.onSubmitHandler(event);
    }, 800);

    const facetForm = this.querySelector('form');
    facetForm.addEventListener('input', this.debouncedOnSubmit.bind(this));

    const facetWrapper = this.querySelector('#FacetsWrapperDesktop');
    if (facetWrapper) facetWrapper.addEventListener('keyup', onKeyUpEscape);
  }

  static setListeners() {
    const onHistoryChange = (event) => {
      const searchParams = event.state ? event.state.searchParams : FacetFiltersForm.searchParamsInitial;
      if (searchParams === FacetFiltersForm.searchParamsPrev) return;
      FacetFiltersForm.renderPage(searchParams, null, false);
    };
    window.addEventListener('popstate', onHistoryChange);
  }

  static toggleActiveFacets(disable = true) {
    document.querySelectorAll('.js-facet-remove').forEach((element) => {
      element.classList.toggle('disabled', disable);
    });
  }

  static renderPage(searchParams, event, updateURLHash = true) {
    FacetFiltersForm.searchParamsPrev = searchParams;
    const sections = FacetFiltersForm.getSections();
    const countContainer = document.getElementById('ProductCount');
    const countContainerDesktop = document.getElementById('ProductCountDesktop');
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.remove('hidden'));
    document.getElementById('ProductGridContainer').querySelector('.collection').classList.add('loading');
    if (countContainer) {
      countContainer.classList.add('loading');
    }
    if (countContainerDesktop) {
      countContainerDesktop.classList.add('loading');
    }

    sections.forEach((section) => {
      const url = `${window.location.pathname}?section_id=${section.section}&${searchParams}`;
      const filterDataUrl = (element) => element.url === url;

      FacetFiltersForm.filterData.some(filterDataUrl)
        ? FacetFiltersForm.renderSectionFromCache(filterDataUrl, event)
        : FacetFiltersForm.renderSectionFromFetch(url, event);
    });

    if (updateURLHash) FacetFiltersForm.updateURLHash(searchParams);
  }

  static renderSectionFromFetch(url, event) {
    fetch(url)
      .then((response) => response.text())
      .then((responseText) => {
        const html = responseText;
        FacetFiltersForm.filterData = [...FacetFiltersForm.filterData, { html, url }];
        FacetFiltersForm.renderFilters(html, event);
        FacetFiltersForm.renderProductGridContainer(html);
        FacetFiltersForm.renderProductCount(html);
        if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
      });
  }

  static renderSectionFromCache(filterDataUrl, event) {
    const html = FacetFiltersForm.filterData.find(filterDataUrl).html;
    FacetFiltersForm.renderFilters(html, event);
    FacetFiltersForm.renderProductGridContainer(html);
    FacetFiltersForm.renderProductCount(html);
    if (typeof initializeScrollAnimationTrigger === 'function') initializeScrollAnimationTrigger(html.innerHTML);
  }

  static renderProductGridContainer(html) {
    document.getElementById('ProductGridContainer').innerHTML = new DOMParser()
      .parseFromString(html, 'text/html')
      .getElementById('ProductGridContainer').innerHTML;

    document
      .getElementById('ProductGridContainer')
      .querySelectorAll('.scroll-trigger')
      .forEach((element) => {
        element.classList.add('scroll-trigger--cancel');
      });
  }

  static renderProductCount(html) {
    const count = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductCount').innerHTML;
    const container = document.getElementById('ProductCount');
    const containerDesktop = document.getElementById('ProductCountDesktop');
    container.innerHTML = count;
    container.classList.remove('loading');
    if (containerDesktop) {
      containerDesktop.innerHTML = count;
      containerDesktop.classList.remove('loading');
    }
    const loadingSpinners = document.querySelectorAll(
      '.facets-container .loading__spinner, facet-filters-form .loading__spinner'
    );
    loadingSpinners.forEach((spinner) => spinner.classList.add('hidden'));
  }

  static renderFilters(html, event) {
    const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
    const facetDetailsElementsFromFetch = parsedHTML.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );
    const facetDetailsElementsFromDom = document.querySelectorAll(
      '#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter, #FacetFiltersPillsForm .js-filter'
    );

    // Remove facets that are no longer returned from the server
    Array.from(facetDetailsElementsFromDom).forEach((currentElement) => {
      if (!Array.from(facetDetailsElementsFromFetch).some(({ id }) => currentElement.id === id)) {
        currentElement.remove();
      }
    });

    const matchesId = (element) => {
      const jsFilter = event ? event.target.closest('.js-filter') : undefined;
      return jsFilter ? element.id === jsFilter.id : false;
    };

    const facetsToRender = Array.from(facetDetailsElementsFromFetch).filter((element) => !matchesId(element));
    const countsToRender = Array.from(facetDetailsElementsFromFetch).find(matchesId);

    facetsToRender.forEach((elementToRender, index) => {
      const currentElement = document.getElementById(elementToRender.id);
      // Element already rendered in the DOM so just update the innerHTML
      if (currentElement) {
        document.getElementById(elementToRender.id).innerHTML = elementToRender.innerHTML;
      } else {
        if (index > 0) {
          const { className: previousElementClassName, id: previousElementId } = facetsToRender[index - 1];
          // Same facet type (eg horizontal/vertical or drawer/mobile)
          if (elementToRender.className === previousElementClassName) {
            document.getElementById(previousElementId).after(elementToRender);
            return;
          }
        }

        if (elementToRender.parentElement) {
          const targetParent = document.getElementById(elementToRender.parentElement.id);
          const firstExistingFilter = targetParent ? targetParent.querySelector('.js-filter') : null;

          if (firstExistingFilter) {
            firstExistingFilter.before(elementToRender);
          } else if (targetParent) {
            targetParent.appendChild(elementToRender);
          }
        }
      }
    });

    FacetFiltersForm.renderActiveFacets(parsedHTML);
    FacetFiltersForm.renderAdditionalElements(parsedHTML);

    if (countsToRender) {
      const closestJSFilterID = event.target.closest('.js-filter').id;

      if (closestJSFilterID) {
        FacetFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
        FacetFiltersForm.renderMobileCounts(countsToRender, document.getElementById(closestJSFilterID));

        const newFacetDetailsElement = document.getElementById(closestJSFilterID);
        const newElementSelector = newFacetDetailsElement.classList.contains('mobile-facets__details')
          ? `.mobile-facets__close-button`
          : `.facets__summary`;
        const newElementToActivate = newFacetDetailsElement.querySelector(newElementSelector);

        const isTextInput = event.target.getAttribute('type') === 'text';

        if (
          newElementToActivate &&
          !isTextInput &&
          !newFacetDetailsElement.classList.contains('dkl-advisor-source')
        ) {
          newElementToActivate.focus();
        }
      }
    }

    if (window.DKLFacetAdvisor) window.DKLFacetAdvisor.refresh();
    if (window.DKLMobileFacetAdvisor) window.DKLMobileFacetAdvisor.refresh();
    if (window.initDKLPriceSliders) window.initDKLPriceSliders();
  }

  static renderActiveFacets(html) {
    const activeFacetElementSelectors = ['.active-facets-mobile', '.active-facets-desktop'];

    activeFacetElementSelectors.forEach((selector) => {
      const activeFacetsElement = html.querySelector(selector);
      if (!activeFacetsElement) return;
      document.querySelector(selector).innerHTML = activeFacetsElement.innerHTML;
    });

    FacetFiltersForm.toggleActiveFacets(false);
  }

  static renderAdditionalElements(html) {
    const mobileElementSelectors = ['.mobile-facets__open', '.mobile-facets__count', '.sorting'];

    mobileElementSelectors.forEach((selector) => {
      if (!html.querySelector(selector)) return;
      document.querySelector(selector).innerHTML = html.querySelector(selector).innerHTML;
    });

    document.getElementById('FacetFiltersFormMobile').closest('menu-drawer').bindEvents();
  }

  static renderCounts(source, target) {
    const targetSummary = target.querySelector('.facets__summary');
    const sourceSummary = source.querySelector('.facets__summary');

    if (sourceSummary && targetSummary) {
      targetSummary.outerHTML = sourceSummary.outerHTML;
    }

    const targetHeaderElement = target.querySelector('.facets__header');
    const sourceHeaderElement = source.querySelector('.facets__header');

    if (sourceHeaderElement && targetHeaderElement) {
      targetHeaderElement.outerHTML = sourceHeaderElement.outerHTML;
    }

    const targetWrapElement = target.querySelector('.facets-wrap');
    const sourceWrapElement = source.querySelector('.facets-wrap');

    if (sourceWrapElement && targetWrapElement) {
      const isShowingMore = Boolean(target.querySelector('show-more-button .label-show-more.hidden'));
      if (isShowingMore) {
        sourceWrapElement
          .querySelectorAll('.facets__item.hidden')
          .forEach((hiddenItem) => hiddenItem.classList.replace('hidden', 'show-more-item'));
      }

      targetWrapElement.outerHTML = sourceWrapElement.outerHTML;
    }
  }

  static renderMobileCounts(source, target) {
    const targetFacetsList = target.querySelector('.mobile-facets__list');
    const sourceFacetsList = source.querySelector('.mobile-facets__list');

    if (sourceFacetsList && targetFacetsList) {
      targetFacetsList.outerHTML = sourceFacetsList.outerHTML;
    }
  }

  static updateURLHash(searchParams) {
    history.pushState({ searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}`);
  }

  static getSections() {
    return [
      {
        section: document.getElementById('product-grid').dataset.id,
      },
    ];
  }

  createSearchParams(form) {
    const formData = new FormData(form);
    return new URLSearchParams(formData).toString();
  }

  onSubmitForm(searchParams, event) {
    FacetFiltersForm.renderPage(searchParams, event);
  }

  onSubmitHandler(event) {
    event.preventDefault();
    const sortFilterForms = document.querySelectorAll('facet-filters-form form');
    if (event.srcElement.className == 'mobile-facets__checkbox') {
      const searchParams = this.createSearchParams(event.target.closest('form'));
      this.onSubmitForm(searchParams, event);
    } else {
      const forms = [];
      const isMobile = event.target.closest('form').id === 'FacetFiltersFormMobile';

      sortFilterForms.forEach((form) => {
        if (!isMobile) {
          if (form.id === 'FacetSortForm' || form.id === 'FacetFiltersForm' || form.id === 'FacetSortDrawerForm') {
            forms.push(this.createSearchParams(form));
          }
        } else if (form.id === 'FacetFiltersFormMobile') {
          forms.push(this.createSearchParams(form));
        }
      });
      this.onSubmitForm(forms.join('&'), event);
    }
  }

  onActiveFilterClick(event) {
    event.preventDefault();
    FacetFiltersForm.toggleActiveFacets();
    const url =
      event.currentTarget.href.indexOf('?') == -1
        ? ''
        : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
    FacetFiltersForm.renderPage(url);
  }
}

FacetFiltersForm.filterData = [];
FacetFiltersForm.searchParamsInitial = window.location.search.slice(1);
FacetFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('facet-filters-form', FacetFiltersForm);
FacetFiltersForm.setListeners();

class PriceRange extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll('input').forEach((element) => {
      element.addEventListener('change', this.onRangeChange.bind(this));
      element.addEventListener('keydown', this.onKeyDown.bind(this));
    });
    this.setMinAndMaxValues();
  }

  onRangeChange(event) {
    this.adjustToValidValues(event.currentTarget);
    this.setMinAndMaxValues();
  }

  onKeyDown(event) {
    if (event.metaKey) return;

    const pattern = /[0-9]|\.|,|'| |Tab|Backspace|Enter|ArrowUp|ArrowDown|ArrowLeft|ArrowRight|Delete|Escape/;
    if (!event.key.match(pattern)) event.preventDefault();
  }

  setMinAndMaxValues() {
    const inputs = this.querySelectorAll('input');
    const minInput = inputs[0];
    const maxInput = inputs[1];
    if (maxInput.value) minInput.setAttribute('data-max', maxInput.value);
    if (minInput.value) maxInput.setAttribute('data-min', minInput.value);
    if (minInput.value === '') maxInput.setAttribute('data-min', 0);
    if (maxInput.value === '') minInput.setAttribute('data-max', maxInput.getAttribute('data-max'));
  }

  adjustToValidValues(input) {
    const value = Number(input.value);
    const min = Number(input.getAttribute('data-min'));
    const max = Number(input.getAttribute('data-max'));

    if (value < min) input.value = min;
    if (value > max) input.value = max;
  }
}

customElements.define('price-range', PriceRange);

class FacetRemove extends HTMLElement {
  constructor() {
    super();
    const facetLink = this.querySelector('a');
    facetLink.setAttribute('role', 'button');
    facetLink.addEventListener('click', this.closeFilter.bind(this));
    facetLink.addEventListener('keyup', (event) => {
      event.preventDefault();
      if (event.code.toUpperCase() === 'SPACE') this.closeFilter(event);
    });
  }

  closeFilter(event) {
    event.preventDefault();
    const form = this.closest('facet-filters-form') || document.querySelector('facet-filters-form');
    form.onActiveFilterClick(event);
  }
}

customElements.define('facet-remove', FacetRemove);

/* =========================================================
   Dein Kleiderladen – Preisregler und Beratungsfilter
   ========================================================= */

(function () {
  function parsePrice(value) {
    if (!value) return 0;
    return Number(String(value).replace('€', '').replace(/\./g, '').replace(',', '.').trim()) || 0;
  }

  function formatPrice(value) {
    return Math.round(value) + ' €';
  }

  function initPriceSlider(priceRange) {
    if (!priceRange || priceRange.dataset.sliderReady === 'true') return;

    const minInput = priceRange.querySelector('input[name="filter.v.price.gte"]');
    const maxInput = priceRange.querySelector('input[name="filter.v.price.lte"]');

    if (!minInput || !maxInput) return;

    const minLimit = parsePrice(minInput.dataset.min || minInput.placeholder || 0);
    const maxLimit = parsePrice(maxInput.dataset.max || maxInput.placeholder || 399);

    if (maxLimit <= minLimit) return;

    const oldSlider = priceRange.parentElement.querySelector(':scope > .dkl-price-slider');
    if (oldSlider) oldSlider.remove();

    const slider = document.createElement('div');
    slider.className = 'dkl-price-slider';

    slider.innerHTML = `
      <div class="dkl-price-slider__values">
        <span class="dkl-price-slider__min">${formatPrice(parsePrice(minInput.value) || minLimit)}</span>
        <span class="dkl-price-slider__max">${formatPrice(parsePrice(maxInput.value) || maxLimit)}</span>
      </div>
      <div class="dkl-price-slider__range">
        <div class="dkl-price-slider__track"></div>
        <div class="dkl-price-slider__fill"></div>
        <input class="dkl-price-slider__min-range" type="range" min="${minLimit}" max="${maxLimit}" value="${parsePrice(minInput.value) || minLimit}" step="1" aria-label="Minimaler Preis">
        <input class="dkl-price-slider__max-range" type="range" min="${minLimit}" max="${maxLimit}" value="${parsePrice(maxInput.value) || maxLimit}" step="1" aria-label="Maximaler Preis">
      </div>
    `;

    priceRange.insertAdjacentElement('afterend', slider);
    priceRange.dataset.sliderReady = 'true';

    const minRange = slider.querySelector('.dkl-price-slider__min-range');
    const maxRange = slider.querySelector('.dkl-price-slider__max-range');
    const minText = slider.querySelector('.dkl-price-slider__min');
    const maxText = slider.querySelector('.dkl-price-slider__max');
    const fill = slider.querySelector('.dkl-price-slider__fill');

    function updateSlider(triggerChange) {
      let minValue = Number(minRange.value);
      let maxValue = Number(maxRange.value);

      if (minValue > maxValue) {
        if (document.activeElement === minRange) {
          maxValue = minValue;
          maxRange.value = maxValue;
        } else {
          minValue = maxValue;
          minRange.value = minValue;
        }
      }

      minInput.value = minValue > minLimit ? minValue : '';
      maxInput.value = maxValue < maxLimit ? maxValue : '';

      minText.textContent = formatPrice(minValue);
      maxText.textContent = formatPrice(maxValue);

      const minPercent = ((minValue - minLimit) / (maxLimit - minLimit)) * 100;
      const maxPercent = ((maxValue - minLimit) / (maxLimit - minLimit)) * 100;

      fill.style.left = minPercent + '%';
      fill.style.right = 100 - maxPercent + '%';

      if (triggerChange) {
        minInput.dispatchEvent(new Event('input', { bubbles: true }));
      }
    }

    minRange.addEventListener('input', function () {
      updateSlider(false);
    });

    maxRange.addEventListener('input', function () {
      updateSlider(false);
    });

    minRange.addEventListener('change', function () {
      updateSlider(true);
    });

    maxRange.addEventListener('change', function () {
      updateSlider(true);
    });

    updateSlider(false);
  }

  window.initDKLPriceSliders = function () {
    document.querySelectorAll('price-range.facets__price').forEach(initPriceSlider);
  };

  const DKLFacetAdvisor = {
    preferredOrder: {
      'material-details': ['material', 'bestickung & muster', 'bestickung und muster'],
      'oberweite-cups': ['oberweite', 'cups'],
      'taille-schnitt': ['taille'],
      'laenge-schlitz': ['länge', 'laenge', 'schlitz'],
      'babybauch-passform': [
        'babybauch',
        'dessert erlaubt. kein einziehen nötig.',
        'dessert erlaubt. kein einziehen noetig.',
      ],
    },

    getRoot() {
      return document.querySelector('#FacetFiltersForm [data-dkl-advisor-root]');
    },

    normalizeLabel(value) {
      return String(value || '').trim().toLocaleLowerCase('de-DE');
    },

    closeGroups(exceptGroup) {
      document.querySelectorAll('#FacetFiltersForm [data-dkl-advisor-group-card][open]').forEach((group) => {
        if (group !== exceptGroup) group.removeAttribute('open');
      });
    },

    bindRoot(root) {
      if (!root || root.dataset.dklBound === 'true') return;
      root.dataset.dklBound = 'true';

      root.addEventListener('toggle', () => {
        if (!root.open) this.closeGroups();
      });
    },

    bindGroup(group) {
      if (!group || group.dataset.dklBound === 'true') return;
      group.dataset.dklBound = 'true';

      group.addEventListener('toggle', () => {
        if (!group.open) return;

        this.closeGroups(group);

        document
          .querySelectorAll('#FacetFiltersForm .facets__wrapper > .facets__disclosure[open]:not(.dkl-advisor-source)')
          .forEach((filter) => filter.removeAttribute('open'));
      });
    },

    createMirrorSource(source, groupName) {
      const clone = source.cloneNode(true);
      const cloneSuffix = `dkl-mirror-${groupName}`;

      clone.classList.remove('dkl-advisor-mirror-source', 'js-filter', 'disclosure-has-popup');
      clone.classList.add('dkl-advisor-source', 'dkl-advisor-source--mirror');
      clone.removeAttribute('data-dkl-advisor-mirror-group');
      clone.removeAttribute('data-index');
      clone.dataset.dklAdvisorGroup = groupName;
      clone.dataset.dklMirrorOf = source.id || '';
      clone.setAttribute('open', '');

      if (clone.id) clone.id = `${clone.id}-${cloneSuffix}`;

      const idMap = new Map();
      clone.querySelectorAll('[id]').forEach((element, index) => {
        const oldId = element.id;
        const newId = `${oldId}-${cloneSuffix}-${index}`;
        idMap.set(oldId, newId);
        element.id = newId;
      });

      clone.querySelectorAll('label[for]').forEach((label) => {
        const mappedId = idMap.get(label.getAttribute('for'));
        if (mappedId) label.setAttribute('for', mappedId);
      });

      clone.querySelectorAll('[aria-controls]').forEach((element) => {
        const mappedId = idMap.get(element.getAttribute('aria-controls'));
        if (mappedId) element.setAttribute('aria-controls', mappedId);
      });

      clone.querySelectorAll('input[type="checkbox"]').forEach((input) => {
        input.dataset.dklOriginalName = input.name;
        input.dataset.dklOriginalValue = input.value;
        input.removeAttribute('name');
      });

      clone.addEventListener('input', (event) => {
        const mirrorInput = event.target.closest('input[type="checkbox"][data-dkl-original-name]');
        if (!mirrorInput) return;

        const originalInput = Array.from(source.querySelectorAll('input[type="checkbox"]')).find(
          (input) =>
            input.name === mirrorInput.dataset.dklOriginalName &&
            input.value === mirrorInput.dataset.dklOriginalValue
        );

        if (originalInput) originalInput.checked = mirrorInput.checked;
      });

      return clone;
    },

    sortTarget(target, groupName) {
      if (!target) return;

      const preferred = this.preferredOrder[groupName] || [];
      const orderFor = (element) => {
        const label = this.normalizeLabel(element.dataset.dklFilterLabel);
        const index = preferred.indexOf(label);
        return index === -1 ? preferred.length + 100 : index;
      };

      Array.from(target.children)
        .sort((a, b) => orderFor(a) - orderFor(b))
        .forEach((element) => target.appendChild(element));
    },

    refresh() {
      const root = this.getRoot();
      if (!root) return;

      this.bindRoot(root);

      root.querySelectorAll('.dkl-advisor-source--mirror').forEach((clone) => clone.remove());

      const sources = document.querySelectorAll(
        '#FacetFiltersForm .dkl-advisor-source[data-dkl-advisor-group]:not(.dkl-advisor-source--mirror)'
      );

      sources.forEach((source) => {
        const groupName = source.dataset.dklAdvisorGroup;
        const target = root.querySelector(`[data-dkl-advisor-target="${groupName}"]`);

        if (!target) return;
        if (source.parentElement !== target) target.appendChild(source);
        source.setAttribute('open', '');
      });

      const mirrorSources = document.querySelectorAll(
        '#FacetFiltersForm .dkl-advisor-mirror-source[data-dkl-advisor-mirror-group]'
      );

      mirrorSources.forEach((source) => {
        const groupName = source.dataset.dklAdvisorMirrorGroup;
        const target = root.querySelector(`[data-dkl-advisor-target="${groupName}"]`);
        if (!target) return;

        const clone = this.createMirrorSource(source, groupName);
        target.appendChild(clone);
      });

      root.querySelectorAll('[data-dkl-advisor-target]').forEach((target) => {
        this.sortTarget(target, target.dataset.dklAdvisorTarget);
      });

      let availableGroups = 0;
      let totalActiveValues = 0;

      root.querySelectorAll('[data-dkl-advisor-group-card]').forEach((group) => {
        this.bindGroup(group);

        const groupName = group.dataset.dklAdvisorGroupCard;
        const target = group.querySelector(`[data-dkl-advisor-target="${groupName}"]`);
        const groupSources = target
          ? Array.from(target.children).filter((child) => child.classList.contains('dkl-advisor-source'))
          : [];

        const hasSources = groupSources.length > 0;
        group.hidden = !hasSources;
        group.classList.toggle('dkl-advisor-group--single', groupSources.length === 1);

        if (target) target.classList.toggle('is-multiple', groupSources.length > 1);
        if (hasSources) availableGroups += 1;

        const activeValues = target
          ? target.querySelectorAll('input[type="checkbox"]:checked').length
          : 0;

        totalActiveValues += activeValues;
        group.classList.toggle('is-active', activeValues > 0);

        const countBadge = group.querySelector('.dkl-advisor-group__count');
        if (countBadge) {
          countBadge.textContent = activeValues;
          countBadge.hidden = activeValues === 0;
        }
      });

      root.hidden = availableGroups === 0;
    },

    init() {
      this.refresh();

      if (!document.documentElement.dataset.dklAdvisorGlobalBound) {
        document.documentElement.dataset.dklAdvisorGlobalBound = 'true';

        document.addEventListener('click', (event) => {
          const openGroup = document.querySelector(
            '#FacetFiltersForm [data-dkl-advisor-group-card][open]'
          );

          if (openGroup && !openGroup.contains(event.target)) this.closeGroups();
        });

        document.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;

          const openGroup = document.querySelector(
            '#FacetFiltersForm [data-dkl-advisor-group-card][open]'
          );

          if (openGroup) {
            const summary = openGroup.querySelector(':scope > summary');
            openGroup.removeAttribute('open');
            if (summary) summary.focus();
          }
        });
      }
    },
  };

  const DKLMobileFacetAdvisor = {
    basicOrder: {
      preis: 0,
      price: 0,
      farbe: 1,
      color: 1,
      'größe': 2,
      groesse: 2,
      size: 2,
      anlass: 3,
      occasion: 3,
      schnitt: 4,
      silhouette: 4,
    },

    groupOrder: {
      'material-details': {
        material: 0,
        'bestickung & muster': 1,
        'bestickung und muster': 1,
      },
      ausschnitt: { ausschnitt: 0 },
      ruecken: { 'rücken': 0, ruecken: 0 },
      'aermel-traeger': {
        'ärmel & träger': 0,
        'ärmel und träger': 0,
        'aermel & traeger': 0,
        'aermel und traeger': 0,
      },
      'oberweite-cups': { oberweite: 0, cups: 1 },
      'taille-schnitt': { taille: 0 },
      'laenge-schlitz': { 'länge': 0, laenge: 0, schlitz: 1 },
      'babybauch-passform': {
        babybauch: 0,
        'dessert erlaubt. kein einziehen nötig.': 1,
        'dessert erlaubt. kein einziehen noetig.': 1,
      },
    },

    groupDefinitions: [
      {
        key: 'material-details',
        title: 'Material & Details',
        icon: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><rect x="5" y="5" width="22" height="22" rx="2" stroke="currentColor" stroke-width="1.4"/><path d="M5 11h22M5 17h22M5 23h22M11 5v22M17 5v22M23 5v22" stroke="currentColor" stroke-width="1" opacity=".75"/></svg>',
      },
      {
        key: 'ausschnitt',
        title: 'Ausschnitt',
        icon: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8 6v7.5C8 20 11.5 25 16 27c4.5-2 8-7 8-13.5V6" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/><path d="M8 10c3.7 0 5.9 1.7 8 5 2.1-3.3 4.3-5 8-5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>',
      },
      {
        key: 'ruecken',
        title: 'Rücken',
        icon: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 6 7 10l3 6-2 11h16l-2-11 3-6-4-4c-1.2 2.5-2.8 3.8-5 3.8S12.2 8.5 11 6Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M12 12c1.2 1.2 2.5 1.8 4 1.8s2.8-.6 4-1.8" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
      },
      {
        key: 'aermel-traeger',
        title: 'Ärmel & Träger',
        icon: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11 6 6 10l3 7 3-2-1 12h10l-1-12 3 2 3-7-5-4-2 5h-6l-2-5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M13 6c.4 2 1.4 3 3 3s2.6-1 3-3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
      },
      {
        key: 'oberweite-cups',
        title: 'Oberweite & Cups',
        icon: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M5 11c3 0 5.2 1.5 6.5 4.5C12.8 12.5 14 11 16 11s3.2 1.5 4.5 4.5C21.8 12.5 24 11 27 11v10c-3.6 0-6.4-1.5-8-4.5-1.6 3-4.4 4.5-8 4.5-3.6 0-6-2-6-5v-5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M16 11v8" stroke="currentColor" stroke-width="1.3"/></svg>',
      },
      {
        key: 'taille-schnitt',
        title: 'Taille',
        icon: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10 5c1.5 4 1.5 7 0 11-1.5 4-1.5 7 0 11h12c1.5-4 1.5-7 0-11-1.5-4-1.5-7 0-11H10Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M10 12h12M10 20h12M14 6v20M18 6v20" stroke="currentColor" stroke-width="1.1" opacity=".8"/></svg>',
      },
      {
        key: 'laenge-schlitz',
        title: 'Länge & Schlitz',
        icon: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13 5h6l1 5 4 17H8l4-17 1-5Z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/><path d="M13 10h7M18 16v11" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
      },
      {
        key: 'babybauch-passform',
        title: 'Babybauch & besondere Passform',
        icon: '<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 5c-2 3-2.5 5.8-1.5 8.5-3 1.7-5 4.3-5 7.5 0 3.6 2.5 6 6 6 4.7 0 7.5-3.5 7.5-8 0-4.2-2.2-7.3-5.5-8.7" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><path d="M10 9c1.5 1.7 3.4 2.5 5.5 2.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>',
      },
    ],

    caretIcon:
      '<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 7.5 10 13l5.5-5.5" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>',

    normalizeLabel(value) {
      return String(value || '').trim().toLocaleLowerCase('de-DE');
    },

    getRoot() {
      return document.getElementById('FacetsWrapperMobile');
    },

    getFilterLabel(filter) {
      if (!filter) return '';
      if (filter.dataset.dklMobileFilterLabel) return filter.dataset.dklMobileFilterLabel;

      const labelElement = filter.querySelector(':scope > .mobile-facets__summary > div > span:first-child');
      const label = this.normalizeLabel(labelElement ? labelElement.textContent : '');
      filter.dataset.dklMobileFilterLabel = label;
      return label;
    },

    getGroupForLabel(label) {
      const normalizedLabel = this.normalizeLabel(label);

      if (normalizedLabel === 'material' || normalizedLabel === 'bestickung & muster' || normalizedLabel === 'bestickung und muster') {
        return 'material-details';
      }
      if (normalizedLabel === 'ausschnitt') return 'ausschnitt';
      if (normalizedLabel === 'rücken' || normalizedLabel === 'ruecken') return 'ruecken';
      if (
        normalizedLabel === 'ärmel & träger' ||
        normalizedLabel === 'ärmel und träger' ||
        normalizedLabel === 'aermel & traeger' ||
        normalizedLabel === 'aermel und traeger'
      ) {
        return 'aermel-traeger';
      }
      if (normalizedLabel === 'oberweite' || normalizedLabel === 'cups') return 'oberweite-cups';
      if (normalizedLabel === 'taille') return 'taille-schnitt';
      if (normalizedLabel === 'länge' || normalizedLabel === 'laenge' || normalizedLabel === 'schlitz') {
        return 'laenge-schlitz';
      }
      if (
        normalizedLabel === 'babybauch' ||
        normalizedLabel === 'dessert erlaubt. kein einziehen nötig.' ||
        normalizedLabel === 'dessert erlaubt. kein einziehen noetig.'
      ) {
        return 'babybauch-passform';
      }

      return '';
    },

    isBasicFilter(filter, label) {
      if (filter && filter.id && filter.id.toLocaleLowerCase('de-DE').includes('price')) return true;
      return Object.prototype.hasOwnProperty.call(this.basicOrder, this.normalizeLabel(label));
    },

    createGroupMarkup() {
      return this.groupDefinitions
        .map(
          ({ key, title, icon }) => `
            <div class="dkl-mobile-advisor-group" data-dkl-mobile-group-card="${key}">
              <div
                class="dkl-mobile-advisor-group__summary"
                role="button"
                tabindex="0"
                aria-expanded="false"
              >
                <span class="dkl-mobile-advisor-group__icon" aria-hidden="true">${icon}</span>
                <span class="dkl-mobile-advisor-group__title">${title}</span>
                <span class="dkl-mobile-advisor-group__count" hidden></span>
                <span class="dkl-mobile-advisor-group__arrow" aria-hidden="true">${this.caretIcon}</span>
              </div>
              <div class="dkl-mobile-advisor-group__panel">
                <div class="dkl-mobile-advisor-group__target" data-dkl-mobile-group-target="${key}"></div>
              </div>
            </div>`
        )
        .join('');
    },

    buildLayout(root) {
      let layout = root.querySelector('[data-dkl-mobile-layout]');
      if (layout) return layout;

      layout = document.createElement('div');
      layout.className = 'dkl-mobile-layout';
      layout.dataset.dklMobileLayout = 'true';
      layout.innerHTML = `
        <section class="dkl-mobile-section dkl-mobile-sort-section" data-dkl-mobile-sort-section>
          <h3 class="dkl-mobile-section__heading">Sortieren</h3>
          <div class="dkl-mobile-sort-target" data-dkl-mobile-sort-target></div>
        </section>

        <section class="dkl-mobile-section dkl-mobile-basic-section" data-dkl-mobile-basic-section>
          <h3 class="dkl-mobile-section__heading">Schnell finden</h3>
          <div class="dkl-mobile-basic-target" data-dkl-mobile-basic-target></div>
        </section>

        <section class="dkl-mobile-section dkl-mobile-advisor-section" data-dkl-mobile-advisor-section>
          <div class="dkl-mobile-advisor-heading">
            <h3 class="dkl-mobile-section__heading">Kleider finden, wie wir beraten würden</h3>
            <p>Schritt für Schritt zu deinem perfekten Kleid.</p>
          </div>
          <div class="dkl-mobile-advisor-groups">${this.createGroupMarkup()}</div>
        </section>

        <section class="dkl-mobile-section dkl-mobile-extra-section" data-dkl-mobile-extra-section hidden>
          <h3 class="dkl-mobile-section__heading">Weitere Filter</h3>
          <div class="dkl-mobile-extra-target" data-dkl-mobile-extra-target></div>
        </section>`;

      const footer = Array.from(root.children).find((element) => element.classList.contains('mobile-facets__footer'));
      root.insertBefore(layout, footer || root.firstChild);
      this.bindLayout(layout);
      return layout;
    },

    bindLayout(layout) {
      if (!layout || layout.dataset.dklMobileBound === 'true') return;
      layout.dataset.dklMobileBound = 'true';

      layout.querySelectorAll('[data-dkl-mobile-group-card]').forEach((group) => {
        const control = group.querySelector('.dkl-mobile-advisor-group__summary');
        if (!control) return;

        const activate = () => this.activateGroup(group);
        control.addEventListener('click', activate);
        control.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          activate();
        });
      });
    },

    bindRoot(root) {
      if (!root || root.dataset.dklMobileRootBound === 'true') return;
      root.dataset.dklMobileRootBound = 'true';

      root.addEventListener('input', () => {
        window.requestAnimationFrame(() => this.updateState(root));
      });

      /*
       * Die Dawn-Menülogik bindet eigene Klick-Handler an den oberen
       * Zurück-Button. Wir fangen Zurück-Klicks bereits in der Capture-Phase
       * ab, damit auch ein per Script geöffneter Unterdialog auf iOS sauber
       * geschlossen wird. Der Anwenden-Button darf danach weiterhin den
       * gesamten Filter-Drawer schließen.
       */
      root.addEventListener(
        'click',
        (event) => {
          const backButton = event.target.closest('[data-dkl-mobile-back], .mobile-facets__close-button');
          if (backButton && root.contains(backButton)) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            /*
             * Bei den Filtern aus „Schnell finden“ kann Dawn das <details>
             * bereits selbst geöffnet haben. In diesem Fall fehlt teilweise
             * unsere Besitzer-Klasse. Deshalb schließen wir zuerst das direkte
             * Eltern-<details> und greifen ersatzweise auf jedes aktuell offene
             * mobile Filter-Untermenü zurück.
             */
            const filterItem =
              backButton.closest('.mobile-facets__details') ||
              root.querySelector('.mobile-facets__details.dkl-mobile-submenu-owner') ||
              root.querySelector('.mobile-facets__details[open]');

            this.closeFilterItem(filterItem, true);
            return;
          }

          const applyButton = event.target.closest('.mobile-facets__submenu .button--primary');
          if (applyButton && root.contains(applyButton)) {
            this.closeFilterItem(applyButton.closest('.mobile-facets__details'), false);
          }
        },
        true
      );

      root.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        const activeFilter = root.querySelector('.mobile-facets__details.dkl-mobile-submenu-owner');
        if (activeFilter) {
          event.preventDefault();
          this.closeFilterItem(activeFilter, true);
          return;
        }

        this.closeGroups();
      });

      const disclosure = root.closest('.mobile-facets__disclosure');
      if (disclosure && disclosure.dataset.dklMobileDisclosureBound !== 'true') {
        disclosure.dataset.dklMobileDisclosureBound = 'true';
        disclosure.addEventListener('toggle', () => {
          if (!disclosure.open) this.closeFilterItem(null, false);
        });
      }
    },

    closeGroups(exceptGroup) {
      const root = this.getRoot();
      if (!root) return;

      root.querySelectorAll('[data-dkl-mobile-group-card].is-open').forEach((group) => {
        if (group === exceptGroup) return;
        group.classList.remove('is-open');
        const control = group.querySelector('.dkl-mobile-advisor-group__summary');
        if (control) control.setAttribute('aria-expanded', 'false');
      });
    },

    getGroupItems(group) {
      const target = group ? group.querySelector('[data-dkl-mobile-group-target]') : null;
      if (!target) return [];
      return Array.from(target.children).filter(
        (child) => child.classList.contains('mobile-facets__details') || child.classList.contains('dkl-mobile-mirror-trigger')
      );
    },

    getDirectChild(element, className) {
      if (!element) return null;
      return Array.from(element.children).find((child) => child.classList.contains(className)) || null;
    },

    getFilterSummary(item) {
      return this.getDirectChild(item, 'mobile-facets__summary');
    },

    getFilterSubmenu(item) {
      return this.getDirectChild(item, 'mobile-facets__submenu');
    },

    closeFilterItem(item, restoreFocus = false) {
      const root = this.getRoot();
      if (!root) return;

      const activeItems = item
        ? [item]
        : Array.from(root.querySelectorAll('.mobile-facets__details.dkl-mobile-submenu-owner'));

      activeItems.forEach((activeItem) => {
        if (!activeItem) return;

        const summary = this.getFilterSummary(activeItem);
        const submenu = this.getFilterSubmenu(activeItem);

        if (submenu) submenu.classList.remove('dkl-mobile-submenu--active');
        activeItem.classList.remove('menu-opening', 'dkl-mobile-submenu-owner');
        activeItem.removeAttribute('open');
        if (summary) summary.setAttribute('aria-expanded', 'false');

        if (restoreFocus) {
          const group = activeItem.closest('[data-dkl-mobile-group-card]');
          const groupControl = group ? group.querySelector('.dkl-mobile-advisor-group__summary') : null;
          const focusTarget = groupControl || summary;
          const returnScroll = Number(activeItem.dataset.dklMobileReturnScroll || 0);

          window.setTimeout(() => {
            root.scrollTop = Number.isFinite(returnScroll) ? returnScroll : 0;

            if (focusTarget) {
              try {
                focusTarget.focus({ preventScroll: true });
              } catch (error) {
                focusTarget.focus();
              }
            }
          }, 0);
        }

        delete activeItem.dataset.dklMobileReturnScroll;
      });

      root.querySelectorAll('.mobile-facets__submenu.dkl-mobile-submenu--active').forEach((submenu) => {
        submenu.classList.remove('dkl-mobile-submenu--active');
      });
      root.classList.remove('submenu-open');
    },

    activateGroup(group) {
      const items = this.getGroupItems(group);
      if (!items.length) return;

      if (items.length === 1) {
        this.closeGroups();
        this.openFilterItem(items[0]);
        return;
      }

      const shouldOpen = !group.classList.contains('is-open');
      this.closeGroups(shouldOpen ? group : null);
      group.classList.toggle('is-open', shouldOpen);

      const control = group.querySelector('.dkl-mobile-advisor-group__summary');
      if (control) control.setAttribute('aria-expanded', String(shouldOpen));
    },

    openFilterItem(item) {
      if (!item) return;

      if (item.classList.contains('dkl-mobile-mirror-trigger')) {
        const sourceId = item.dataset.dklMobileMirrorSource;
        const source = sourceId ? document.getElementById(sourceId) : null;
        if (source) this.openFilterItem(source);
        return;
      }

      const summary = this.getFilterSummary(item);
      const submenu = this.getFilterSubmenu(item);
      const root = this.getRoot();

      if (!summary || !submenu || !root) return;

      /*
       * Auf echtem Mobile Safari kann ein absolut positioniertes Untermenü
       * unsichtbar bleiben, wenn sein übergeordnetes Drawer-Element zuvor
       * mit visibility:hidden ausgeblendet wurde. Chrome Device Mode bildet
       * dieses Safari-Verhalten nicht nach. Deshalb erhält das aktive Menü
       * jetzt synchron eine eigene sichtbare Klasse; die Darstellung hängt
       * nicht mehr vom doppelten requestAnimationFrame ab.
       */
      this.closeFilterItem(null, false);

      /*
       * Der Hauptbereich ist selbst scrollbar. Wird ein Filter weiter unten
       * in der Übersicht geöffnet, behält iOS Safari sonst dessen bisherigen
       * Scrollstand bei. Das absolut positionierte Untermenü beginnt dann
       * oberhalb des sichtbaren Ausschnitts und zunächst ist nur sein Footer
       * zu sehen. Wir merken uns die Ausgangsposition für „Zurück“ und richten
       * den Unterdialog nach dem Öffnen zuverlässig am oberen Rand aus.
       */
      item.dataset.dklMobileReturnScroll = String(root.scrollTop || 0);

      item.setAttribute('open', '');
      item.classList.add('menu-opening', 'dkl-mobile-submenu-owner');
      summary.setAttribute('aria-expanded', 'true');
      submenu.classList.add('dkl-mobile-submenu--active');
      root.classList.add('submenu-open');

      const list = submenu.querySelector('.mobile-facets__list');
      const alignSubmenuToTop = () => {
        root.scrollTop = 0;
        submenu.scrollTop = 0;
        if (list) list.scrollTop = 0;
      };

      alignSubmenuToTop();
      window.requestAnimationFrame(() => {
        alignSubmenuToTop();
        window.requestAnimationFrame(alignSubmenuToTop);
      });

      const closeButton = submenu.querySelector('.mobile-facets__close-button');
      if (closeButton) {
        window.setTimeout(() => {
          try {
            closeButton.focus({ preventScroll: true });
          } catch (error) {
            closeButton.focus();
          }
          alignSubmenuToTop();
        }, 0);
      }
    },

    enhanceFilter(filter) {
      if (!filter) return;

      const summary = this.getFilterSummary(filter);
      const arrow = summary ? summary.querySelector('.mobile-facets__arrow') : null;
      if (arrow) arrow.innerHTML = this.caretIcon;

      /*
       * Alle mobilen Filter – insbesondere Preis, Farbe, Größe, Anlass und
       * Schnitt unter „Schnell finden“ – werden über dieselbe eigene
       * Öffnungslogik gestartet. Dadurch erhalten auch diese Filter zuverlässig
       * die Klassen und den gespeicherten Scrollstand, die beide Zurück-Buttons
       * zum Schließen benötigen. Der Capture-Handler verhindert, dass Dawns
       * paralleler Summary-Handler denselben Dialog ein zweites Mal öffnet.
       */
      if (summary && summary.dataset.dklMobileOpenBound !== 'true') {
        summary.dataset.dklMobileOpenBound = 'true';
        summary.addEventListener(
          'click',
          (event) => {
            if (!window.matchMedia('(max-width: 749px)').matches) return;

            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();
            this.openFilterItem(filter);
          },
          true
        );
      }
    },

    createMirrorTrigger(source, target, label) {
      if (!source || !target || !source.id) return null;

      const trigger = document.createElement('div');
      trigger.className = 'dkl-mobile-mirror-trigger';
      trigger.setAttribute('role', 'button');
      trigger.setAttribute('tabindex', '0');
      trigger.dataset.dklMobileMirrorSource = source.id;
      trigger.dataset.dklMobileFilterLabel = this.normalizeLabel(label);
      trigger.innerHTML = `
        <span class="dkl-mobile-mirror-trigger__title">${label}</span>
        <span class="dkl-mobile-mirror-trigger__count" hidden></span>
        <span class="dkl-mobile-mirror-trigger__arrow" aria-hidden="true">${this.caretIcon}</span>`;

      const activate = () => this.openFilterItem(trigger);
      trigger.addEventListener('click', activate);
      trigger.addEventListener('keydown', (event) => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        activate();
      });

      target.appendChild(trigger);
      return trigger;
    },

    sortTarget(target, rankMap) {
      if (!target) return;
      const children = Array.from(target.children);
      const sortedChildren = children.slice().sort((first, second) => {
        const firstLabel = this.normalizeLabel(first.dataset.dklMobileFilterLabel || this.getFilterLabel(first));
        const secondLabel = this.normalizeLabel(second.dataset.dklMobileFilterLabel || this.getFilterLabel(second));
        const firstRank = Object.prototype.hasOwnProperty.call(rankMap, firstLabel) ? rankMap[firstLabel] : 999;
        const secondRank = Object.prototype.hasOwnProperty.call(rankMap, secondLabel) ? rankMap[secondLabel] : 999;
        return firstRank - secondRank;
      });

      sortedChildren.forEach((element, index) => {
        if (target.children[index] !== element) target.appendChild(element);
      });
    },

    getItemActiveCount(item) {
      if (!item) return 0;

      if (item.classList.contains('dkl-mobile-mirror-trigger')) {
        const source = item.dataset.dklMobileMirrorSource
          ? document.getElementById(item.dataset.dklMobileMirrorSource)
          : null;
        return source ? source.querySelectorAll('input[type="checkbox"]:checked').length : 0;
      }

      const checkedValues = item.querySelectorAll('input[type="checkbox"]:checked').length;
      const priceValues = Array.from(item.querySelectorAll('input[type="number"]')).filter((input) => input.value !== '').length;
      return checkedValues + priceValues;
    },

    updateState(root) {
      if (!root) return;

      const basicTarget = root.querySelector('[data-dkl-mobile-basic-target]');
      const sortTarget = root.querySelector('[data-dkl-mobile-sort-target]');
      const extraTarget = root.querySelector('[data-dkl-mobile-extra-target]');
      const basicSection = root.querySelector('[data-dkl-mobile-basic-section]');
      const sortSection = root.querySelector('[data-dkl-mobile-sort-section]');
      const extraSection = root.querySelector('[data-dkl-mobile-extra-section]');
      const advisorSection = root.querySelector('[data-dkl-mobile-advisor-section]');

      if (basicSection) basicSection.hidden = !basicTarget || basicTarget.children.length === 0;
      if (sortSection) sortSection.hidden = !sortTarget || sortTarget.children.length === 0;
      if (extraSection) extraSection.hidden = !extraTarget || extraTarget.children.length === 0;

      let availableGroups = 0;

      root.querySelectorAll('[data-dkl-mobile-group-card]').forEach((group) => {
        const items = this.getGroupItems(group);
        const hasItems = items.length > 0;
        group.hidden = !hasItems;
        group.classList.toggle('dkl-mobile-advisor-group--single', items.length === 1);

        if (!hasItems) {
          group.classList.remove('is-open', 'is-active');
          const hiddenControl = group.querySelector('.dkl-mobile-advisor-group__summary');
          if (hiddenControl) hiddenControl.setAttribute('aria-expanded', 'false');
          return;
        }

        availableGroups += 1;
        const activeValues = items.reduce((sum, item) => sum + this.getItemActiveCount(item), 0);
        group.classList.toggle('is-active', activeValues > 0);

        const countBadge = group.querySelector('.dkl-mobile-advisor-group__count');
        if (countBadge) {
          countBadge.textContent = activeValues;
          countBadge.hidden = activeValues === 0;
        }

        items.forEach((item) => {
          if (!item.classList.contains('dkl-mobile-mirror-trigger')) return;
          const mirrorCount = this.getItemActiveCount(item);
          const mirrorBadge = item.querySelector('.dkl-mobile-mirror-trigger__count');
          if (mirrorBadge) {
            mirrorBadge.textContent = mirrorCount;
            mirrorBadge.hidden = mirrorCount === 0;
          }
        });
      });

      if (advisorSection) advisorSection.hidden = availableGroups === 0;
    },

    enhanceStaticElements() {
      document.querySelectorAll('.mobile-facets__heading').forEach((heading) => {
        heading.textContent = 'Filtern & Sortieren';
      });

      const openControl = document.querySelector('.mobile-facets__open');
      if (openControl) {
        openControl.querySelectorAll('.mobile-facets__open-label').forEach((label) => {
          label.textContent = 'Filtern & Sortieren';
        });

        if (!openControl.querySelector('.dkl-mobile-filter-icon')) {
          const icon = document.createElement('span');
          icon.className = 'dkl-mobile-filter-icon';
          icon.setAttribute('aria-hidden', 'true');
          icon.innerHTML = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M4 7h10M18 7h2M4 17h2M10 17h10M9 4v6M15 14v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/><circle cx="16" cy="7" r="2" stroke="currentColor" stroke-width="1.6"/><circle cx="8" cy="17" r="2" stroke="currentColor" stroke-width="1.6"/></svg>';
          openControl.prepend(icon);
        }

        if (!openControl.querySelector('.dkl-mobile-open-caret')) {
          const caret = document.createElement('span');
          caret.className = 'dkl-mobile-open-caret';
          caret.setAttribute('aria-hidden', 'true');
          caret.innerHTML = this.caretIcon;
          openControl.appendChild(caret);
        }
      }

      const root = this.getRoot();
      if (!root) return;

      const footer = Array.from(root.children).find((element) => element.classList.contains('mobile-facets__footer'));
      const resetLink = footer ? footer.querySelector('.mobile-facets__clear') : null;
      if (resetLink) resetLink.textContent = 'Alle Filter zurücksetzen';
    },

    refresh() {
      const root = this.getRoot();
      if (!root) return;

      this.enhanceStaticElements();
      this.bindRoot(root);
      const layout = this.buildLayout(root);
      if (!layout) return;

      const sortTarget = layout.querySelector('[data-dkl-mobile-sort-target]');
      const basicTarget = layout.querySelector('[data-dkl-mobile-basic-target]');
      const extraTarget = layout.querySelector('[data-dkl-mobile-extra-target]');

      layout.querySelectorAll('.dkl-mobile-mirror-trigger').forEach((trigger) => trigger.remove());

      const filters = Array.from(root.querySelectorAll('.mobile-facets__details.js-filter'));
      filters.forEach((filter) => {
        if (filter.id && filter.id.includes('Details-Mobile-SortBy-')) {
          filter.classList.add('dkl-mobile-sort-filter');
          if (sortTarget && filter.parentElement !== sortTarget) sortTarget.appendChild(filter);
          return;
        }

        const label = this.getFilterLabel(filter);
        const groupName = this.getGroupForLabel(label);
        const isBasic = this.isBasicFilter(filter, label);

        filter.classList.remove('dkl-mobile-basic-filter', 'dkl-mobile-advisor-filter', 'dkl-mobile-extra-filter');
        this.enhanceFilter(filter);

        if (isBasic) {
          filter.classList.add('dkl-mobile-basic-filter');
          if (basicTarget && filter.parentElement !== basicTarget) basicTarget.appendChild(filter);
          return;
        }

        if (groupName) {
          const groupTarget = layout.querySelector(`[data-dkl-mobile-group-target="${groupName}"]`);
          filter.classList.add('dkl-mobile-advisor-filter');
          if (groupTarget && filter.parentElement !== groupTarget) groupTarget.appendChild(filter);
          return;
        }

        filter.classList.add('dkl-mobile-extra-filter');
        if (extraTarget && filter.parentElement !== extraTarget) extraTarget.appendChild(filter);
      });

      this.sortTarget(basicTarget, this.basicOrder);
      Object.entries(this.groupOrder).forEach(([groupName, rankMap]) => {
        const target = layout.querySelector(`[data-dkl-mobile-group-target="${groupName}"]`);
        this.sortTarget(target, rankMap);
      });

      root.classList.add('dkl-mobile-ready');
      this.updateState(root);
    },

    init() {
      this.refresh();
    },
  };

  window.DKLFacetAdvisor = DKLFacetAdvisor;
  window.DKLMobileFacetAdvisor = DKLMobileFacetAdvisor;

  function initDKLFacetFeatures() {
    window.DKLFacetAdvisor.init();
    window.DKLMobileFacetAdvisor.init();
    window.initDKLPriceSliders();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initDKLFacetFeatures, { once: true });
  } else {
    initDKLFacetFeatures();
  }

  document.addEventListener('shopify:section:load', initDKLFacetFeatures);
})();

